import React, { FC, useContext, useState } from 'react'

import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'

import MainModal from './common/MainModal'
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from '../ui/form'
import { Input } from '../ui/input'

import { MODAL_CONSTS } from '../../const/modal-const'
import { HandleModalContext } from '../../layout/mainlayout/MainLayout'
import * as yup from 'yup'
import { IconCheckBook } from '../icons/IconCheckBook'
import { Button } from '../ui/button'
import { Loader2Icon } from 'lucide-react'

type ICheckDetails = {
  checkNumber: string
  checkMemo: string
}

export const checkDetailsShema = yup.object().shape({
  checkNumber: yup.string().required('Check number is required'),
  checkMemo: yup.string(),
})

interface CheckDetailsModalProps {
  dataToPassOn: {
    onSave: (values: ICheckDetails) => Promise<void>
  }
}

export const CheckDetailsModal: FC<CheckDetailsModalProps> = ({ dataToPassOn }) => {
  const handleModalContext = useContext(HandleModalContext)
  const handleModal = handleModalContext?.handleModal

  const [loading, setLoading] = useState(false)

  const form = useForm<ICheckDetails>({
    resolver: yupResolver(checkDetailsShema),
    defaultValues: {
      checkNumber: '',
      checkMemo: '',
    },
  })

  const onSubmit = async (data: ICheckDetails) => {
    try {
      setLoading(true)
      await dataToPassOn.onSave(data)
      handleModal?.(false, MODAL_CONSTS.CHECK_DETAILS)
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <MainModal
      customTitle={
        <h4 className="flex items-center gap-2 mb-6 font-bold text-lg">
          <IconCheckBook className="w-5 fill-black" />
          Enter Check Details
        </h4>
      }
      show={true}
      type="CHECK_DETAILS"
      size="sm"
      setHeightAsPerContent={true}
    >
      <div className="text-SeabiscuitDark200ThemeColor">
        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4 w-full">
            <FormField
              control={form.control}
              name="checkNumber"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Check Number</FormLabel>
                  <FormControl>
                    <Input
                      disabled={loading}
                      type="text"
                      placeholder="Enter Check Number"
                      className="w-full"
                      {...field}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="checkMemo"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Memo (Optional)</FormLabel>
                  <FormControl>
                    <Input
                      disabled={loading}
                      type="text"
                      placeholder="Enter Check Number"
                      className="w-full"
                      {...field}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <div className="flex justify-end items-center gap-2">
              <Button
                variant="outline"
                type="button"
                disabled={loading}
                onClick={() => handleModal?.(false, MODAL_CONSTS.CHECK_DETAILS)}
              >
                Cancel
              </Button>
              <Button type="submit" disabled={loading}>
                {loading && <Loader2Icon className="animate-spin w-4" />}
                Record Check
              </Button>
            </div>
          </form>
        </Form>
      </div>
    </MainModal>
  )
}
